import { createApp } from 'vue'

import App from './App.vue'
import router from './router'
import './styles/style.css'

import * as Sentry from '@sentry/vue'

/* Add Pinia store */
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'

const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)

/* Create app */
const app = createApp(App)
app.use(pinia)
app.use(router)

import { useLabelStore } from '@/stores/label'
const labelStore = useLabelStore()

if (import.meta.env.PROD) {
    Sentry.init({
        app,
        dsn: 'https://3eeace986d3ae342ceb940efe28767d4@o1211307.ingest.us.sentry.io/4509003674943488',
        beforeSend(event) {
            // Add custom data to every event
            event.extra = {
                ...event.extra,
                senseDataUrl: labelStore.senseDataUrl
            }
            return event
        }
    })
}

app.mount('#app')
